module.exports = __webpack_public_path__ + "static/media/12UNCTAD5.eed4e27f.jpg";